import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { first } from 'rxjs/operators';
import { Package } from '../../packages/package.models';
import { PermissionsService } from '../services/permissions.service';

@Component({
  selector: 'xp-package',
  template: `
    <div class="package-header">
      <div class="package-header-icon">
        <svg *ngIf="package.flow_type === 'dataflow'" class="icon icons-master-expanded_icon-navmain-packages">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            href="#img-sprite_icons-master-expanded_icon-navmain-packages"
          ></use>
        </svg>
        <svg
          *ngIf="package.flow_type === 'workflow'"
          class="icon icons-master-expanded_icon-navmain-packages icon-workflow"
        >
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            href="#img-sprite_icon-icons-master-expanded_icon-navmain-workflow"
          ></use>
        </svg>
      </div>
      <div class="package-header-info">
        <div class="package-header-name">
          {{ package.name | xpLengthCheck: 50 }}
        </div>
        <div class="package-header-version" *ngxPermissionsOnly="'versionControl'">
          <span class="version" *ngIf="package.paper_trail_package_version && !hideVersion"
            >Version: {{ package.package_version }}</span
          >
          <span
            class="version"
            *ngIf="(!package.paper_trail_package_version || package.paper_trail_package_version === 0) && !hideVersion"
            >Version: Always use latest</span
          >
        </div>
        <div class="package-header-workspace" *ngIf="package.workspace">
          <span class="workspace">Workspace: {{ package.workspace.name }}</span>
        </div>
      </div>
      <div class="package-header-buttons">
        <button type="button" class="btn btn-default btn-sm" (click)="openPackage(package)">
          <i class="fa fa-external-link"></i> open
        </button>
        <button *ngIf="!hideEdit" type="button" class="btn btn-default btn-sm" (click)="editPackage(package)">
          <i class="fa fa-edit"></i> edit
        </button>
        <button type="button" class="btn btn-default btn-sm" (click)="removePackage(package)">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
  `,
})
export class XpPackageComponent {
  @Input() package: Package;
  @Input() hideEdit: boolean;
  @Input() hideVersion: boolean;
  @Output() remove = new EventEmitter<Package>();
  @Output() edit = new EventEmitter<Package>();

  constructor(private permissionsService: PermissionsService, @Inject('$stateParams') private $stateParams: any) {}

  isVersionControlDisabled() {
    return this.permissionsService.hasPermission('versionControl');
  }

  openPackage(packageItem): void {
    this.isVersionControlDisabled()
      .pipe(first())
      .subscribe((hasPermission) => {
        if (
          packageItem.paper_trailpackageItem_version === 0 ||
          packageItem.paper_trailpackageItem_version === undefined ||
          !hasPermission
        ) {
          window.open(`/${this.$stateParams.account_id}/packages/${packageItem.id}/edit`);
        } else {
          window.open(
            `/${this.$stateParams.account_id}/packages/${packageItem.id}/versions/${packageItem.paper_trail_package_version}`,
          );
        }
      });
  }

  removePackage(packageItem: Package) {
    this.remove.emit(packageItem);
  }

  editPackage(packageItem: Package) {
    this.edit.emit(packageItem);
  }
}
